module.exports = "query Users ($company: String = \"\", $search_type: String = \"document\", $search: String = \"\", $page: Int = 1, $limit: Int = 10, $asc: String = \"name\", $status: String) {\n  users (page: $page, limit: $limit, asc: $asc, status: $status, search: $search, search_type: $search_type, company: $company) {\n    data {\n      id\n      name\n      email\n      document\n      companies {\n        id\n        company_id\n        name\n      }\n    }\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/Users.graphql
// module id = EpDq
// module chunks = 1624